import { useEffect, useState } from "react";
import { api, type MeResponse } from "../api";
import { navigate } from "../router";

export function ProfilePage() {
  const [data, setData] = useState<MeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.me().then(setData).catch((e: Error) => setError(e.message));
  }, []);

  if (error) return <ErrorCard message={error} />;
  if (!data) return <Loading />;

  const u = data.user;
  const winRate = Math.round(u.winRate * 100);

  return (
    <div className="screen">
      <header className="header">
        <h1>📊 پروفایل</h1>
      </header>
      <div className="card center">
        {u.avatarUrl && <img className="avatar" src={u.avatarUrl} alt="" />}
        <h2>{u.firstName ?? "بازیکن"} {u.lastName ?? ""}</h2>
        {u.username && <p className="muted" dir="ltr">@{u.username}</p>}
      </div>
      <div className="card grid2">
        <Stat label="بازی‌ها" value={u.gamesPlayed} />
        <Stat label="برد" value={u.gamesWon} />
        <Stat label="باخت" value={u.gamesLost} />
        <Stat label="نرخ برد" value={`${winRate}٪`} />
        <Stat label="امتیاز" value={u.rating} />
      </div>
      <button className="btn block" onClick={() => navigate("home")}>🏠 بازگشت</button>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="stat">
      <div className="stat-value">{value}</div>
      <div className="muted">{label}</div>
    </div>
  );
}

export function Loading() {
  return (
    <div className="screen center">
      <div className="spinner" />
    </div>
  );
}

export function ErrorCard({ message }: { message: string }) {
  return (
    <div className="screen center">
      <div className="card">
        <h2>⚠️ خطا</h2>
        <p>{message}</p>
        <button className="btn block" onClick={() => navigate("home")}>🏠 بازگشت</button>
      </div>
    </div>
  );
}
